import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import { format } from 'date-fns';
import './App.css';
import logo from './hi-level_logo.png';
import Viewer from './containers/Viewer';
import { usePageView } from './analytics/use-page-view';
import { environment } from './environments/environment';

const client = new ApolloClient({
  link: new HttpLink({ uri: environment.graphql.uri }),
  cache: new InMemoryCache(),
});

const App: React.FC = () => {
  return (
    <ApolloProvider client={client}>
      <Router>
        <div className="flex flex-col h-screen bg-gray-100">
          <header className="bg-brand-dark shadow-md z-20">
            <div className="flex items-center justify-between px-5 py-3">
              <div className="flex items-center gap-3">
                <img alt="Hi-Level Logo" src={logo} className="h-8" />
                <div className="h-5 w-px bg-white/20" />
                <span className="text-sm font-semibold tracking-wide text-white/90">
                  MezzViewer
                </span>
              </div>
            </div>
          </header>

          <main className="flex-1 overflow-hidden">
            <Routes>
              <Route path="/:uuid" element={<TrackedViewer />} />
            </Routes>
          </main>

          <footer className="bg-brand-dark/95 px-5 py-2 text-center">
            <small className="text-white/40 text-xs">
              &copy; 2016&ndash;{format(new Date(), 'yyyy')} The Mezzanine Floor Group Ltd. All
              rights reserved. &middot;{' '}
              <a
                href="https://www.hi-levelmezzanines.co.uk/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/50 hover:text-white/70 transition-colors"
              >
                Privacy Policy
              </a>{' '}
              &middot; v{__APP_VERSION__}
            </small>
          </footer>
        </div>
      </Router>
    </ApolloProvider>
  );
};

const TrackedViewer = () => {
  usePageView('viewer');
  return <Viewer />;
};

export default App;
